import React from 'react'
import { FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn, FaInstagram } from 'react-icons/fa'

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-start">
            <div>
              ©2020 K Effect. All rights reserved. 
            </div>
            <div className="footer-links">
              <a href="/privacy-policy" target="_blank">Privacy Policy</a>
              <a href="" target="_blank">Terms & Conditions</a>
            </div>
          </div>
          <div className="footer-end">
            <a href="" target="_blank"><FaFacebookF/></a>
            <a href="" target="_blank"><FaTwitter/></a>
            <a href="" target="_blank"><FaYoutube/></a>
            <a href="" target="_blank"><FaLinkedinIn/></a>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
